import React, { memo } from 'react';
import resolveCustomerDisplayName from '../../utils/customerDisplayName';

const WaitingIncomingCallRow = memo(({ callInfoData }) => {
  const displayName = resolveCustomerDisplayName(callInfoData?.customer);
  const subtitle = callInfoData?.callerNumber || '';

  return (
    <li className="tw-border-b tw-border-gray-100 last:tw-border-0 tw-py-2 tw-px-3">
      <div className="tw-text-sm tw-font-medium tw-text-gray-900 tw-truncate" title={displayName || subtitle}>
        {displayName || subtitle}
      </div>
      {displayName && subtitle && (
        <div className="tw-text-xs tw-text-gray-500 tw-truncate">{subtitle}</div>
      )}
    </li>
  );
});

WaitingIncomingCallRow.displayName = 'WaitingIncomingCallRow';

export default WaitingIncomingCallRow;
